import { render } from "./leftBar2.vue?vue&type=template&id=2347039d"
import script from "./leftBar2.vue?vue&type=script&lang=js"
export * from "./leftBar2.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__